// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__nfz_E","logo":"Home_logo__3auvB","title":"Home_title__1RtlI","description":"Home_description__lfEjm","btnIcon":"Home_btnIcon__T72c3","cta":"Home_cta__20GFA"};